<template>
  <div class="container">
    <div class="row">
      <div class="col-12 flex-column h-100 ">
        <!-- GERAR PIX -->
        <div class="card p-3" v-if="!cobrancaPix">
            <div class=" checkout-corpo mt-1 ">
                <div class="card card-checkout card-pix shadow-sm">
                  <div class="card-body">
                    <div class="row">
                      <div class="mb-2 ml-md-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-clock mt-3"
                          viewBox="0 0 16 16">
                          <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                          <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                        </svg>
                      </div>
                      <div class="col-12">
                        <h6 class="italic ml-3">Aprovação imediata</h6>
                        <div class="texto-seguranca ml-3 mb-2">O pagamento com Pix leva pouco tempo para ser processado.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card card-checkout card-pix  shadow-sm mt-2">
                  <div class="card-body">
                    <div class="row">
                      <div class="mb-2 ml-md-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                          class="bi bi-shield-shaded  mt-2" viewBox="0 0 16 16">
                          <path fill-rule="evenodd"
                            d="M8 14.933a1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56" />
                        </svg>
                      </div>
                      <div class="col-12">
                        <h6 class="italic ml-3">Transação segura</h6>
                        <div class="texto-seguranca ml-3 mb-2"> O PIX foi desenvolvido pelo Banco Central para facilitar suas
                          compras, garantindo a proteção dos seus dados</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card card-checkout card-pix  shadow-sm mt-2">
                  <div class="card-body">
                    <div class="row">
                      <div class="mb-2 ml-md-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                          class="bi bi-qr-code-scan mt-2" viewBox="0 0 16 16">
                          <path fill="currentColor"
                            d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5M.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5M4 4h1v1H4z" />
                          <path fill="currentColor" d="M7 2H2v5h5zM3 3h3v3H3zm2 8H4v1h1z" />
                          <path fill="currentColor" d="M7 9H2v5h5zm-4 1h3v3H3zm8-6h1v1h-1z" />
                          <path
                            d="M9 2h5v5H9zm1 1v3h3V3zM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8zm2 2H9V9h1zm4 2h-1v1h-2v1h3zm-4 2v-1H8v1z" />
                          <path fill="currentColor" d="M12 9h2V8h-2z" />
                        </svg>
                      </div>
                      <div class="col-12">
                        <h6 class="italic ml-3">Finalize sua compra com facilidade</h6>
                        <div class="texto-seguranca ml-3 mb-2">O pagamento com Pix leva pouco tempo para ser processado.</div>
                      </div>
                    </div>
                  </div>
                </div>                      
              </div>
              <div class="mt-2 mb-5 px-3 col-12 d-flex flex-column justify-content-center">
                <button type="button" class="btn btn_color_system py-2 px-5 mt-4" @click="gerarPix2">
                  GERAR PIX
                </button>
              </div>
        </div>
        <!-- DIV PIX -->
        <div class="card p-3 text-center" v-if="cobrancaPix">
          <div class="px-5 pb-4">
            Escaneie o Qrcode ou copie a chave PIX para realizar o pagamento.
          </div>
          <div>
            <span class="container text-center px-3 px-lg-5" v-if="cobrancaPix != null && chavePix != null">
              <img class="w-25 mt-5 mb-3" style="
                  min-width: 180px;
                  max-width: 270px;
                  margin-top: 0px !important;
                " v-bind:src="cobrancaPix.linkQrCode" alt="Cobrança Pix" />
              <br />
            </span>
          </div>
          <div @click="copiarChavePix" class="card p-2">
            <span class="m-3 text-success" v-if="copiaSucesso">Código copiado com sucesso.</span>
            <strong class="border-bottom pb-2 mb-3">Pix Copia e Cola </strong>
            <div style="cursor: pointer" @click="copiarChavePix">
              <i class="fa-solid fa-clone icon"></i>
            </div>
            <input style="opacity: 0; height: 0" id="chavePix" :value="chavePix" />
          </div>

          <div class="row m-3 mt-2">
            <div class="col">
              <p class="mb-0 fw-bold h4">
                <strong>R$ {{ formatPrice(cobrancaPix ? cobrancaPix.valor : 0) }}</strong>
              </p>
            </div>
          </div>

          <div class="card aviso px-3 d-block py-2 border-0" v-if="!erro">
            <div class="text-center">
              <b> Instruções para realizar o pagamento. </b>

              <p class="mt-3">
                Copie a cole o código da chave pix no aplicativo do seu banco ou
                abra o aplicativo escolha pagar com QrCode e aponte a câmera
                para o QrCode.
              </p>
              <p class="mt-3">
                Após o processamento do pagamento os serviços serão liberados para utilização.
              </p>

            </div>
          </div>
        </div>

        <div v-if="erro" class="card my-5 badge-danger text-center p-3 text-uppercase">
          {{ erro.title }}
        </div>
      </div>

      <div v-if="erro" class=" row  col-12  my-2 badge-danger text-center p-3 text-uppercase mt-3">
        {{ erro }}
      </div>
    </div>
    <Loading v-if="loading" :textoMensagem="mensagemLoading"></Loading>
  </div>
</template>

<script>

import icons from "@/shared/components/SvgIcon.js";
import { APIService } from "../../APIService";
import Loading from "@/components/Loading.vue";

const apiService = new APIService();

export default {
  name: "CheckoutCartao",
  components: {Loading},
  props: [],
  data() {
    return {
      icons,
      copiaSucesso: false,
      urlPdf: null,
      cobrancaPix: null,
      chavePix: null,
      cobrancaPixId: null,
      statusCobrancaPix: "ATIVA",
      destroy: false,
      detailRecorrencia: null,
      plano: null,
      erro: null,
      mensagemLoading: "",
      loading: false,
      modeloCobranca: null
    };
  },
  mounted() {
    const _plano = localStorage.getItem("simulacao-plano");
    if (_plano) {
      this.plano = JSON.parse(_plano);
    }

    if (!this.cobrancaPix) {
      // this.gerarPix();
      // this.loadDetailRecorrencia();
    }
  },
  methods: {
    copiarChavePix() {
      document.getElementById("chavePix").select();
      document.execCommand("copy");
      this.copiaSucesso = true;
      setTimeout(() => {
        this.copiaSucesso = false;
      }, 2000);
    },
    gerarPix() {
      apiService
        .obterPixPagamentoRecorrente(this.plano.recorrenciaId)
        .then((res) => {
          this.cobrancaPix = res;
          this.chavePix = res.emv;
          this.btnloading = false;
          this.obterCobrancaPixCallback(res.id);
        })
        .catch((error) => {
          this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title
        })

    },
    gerarPix2() {
      // Todo samuel Ajustar rota para pegar pagamento
      this.loading = true;
      this.mensagemLoading = "Estamos gerando o seu PIX. Por favor, aguarde um momento."
      this.modeloCobranca = this.plano.metodoPagamento.find(metodo => metodo.formaPagamento === "PIX");

      apiService
        .gerarPagamento(this.plano.planoId, this.modeloCobranca.modeloCobrancaId)
        .then((resPagamentoId) => {

        apiService
          .obterPagamentoPix(resPagamentoId.result.id)
          .then((resPix) => {

            this.cobrancaPix = resPix;
            this.chavePix = resPix.emv;
            this.btnloading = false;
            this.loading = false;
            this.obterCobrancaPixCallback(resPagamentoId.result.id);
          })
          .catch((error) => (
              this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title,
              this.loading = false
            ));
        })
        .catch((error) => (
          this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title,
          this.loading = false
        ));
    },
    loadDetailRecorrencia() {

      if (this.assinaturaId > 0) {
        apiService
          .obterMinhaAssinaturaID(this.plano.recorrenciaId)
          .then((response) => {
            this.detailRecorrencia = response;
          }).catch((error) => {
            this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title
          });
      }
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    obterCobrancaPixCallback(value) {
      apiService
        .obterCobrancaPixPorId(value)
        .then((res) => {
          let step = "";

          if (res.origem === "ASSINATURA") {
            step = "assinaturas";
          } else if (res.origem === "MARKETPLACE") {
            step = "pedidos";
          }

          if (res.status === "ATIVA" && this.destroy === false) {
            setTimeout(() => {
              //refaz a solicitacao
              this.obterCobrancaPixCallback(value);
            }, 2000);
          } else if (res.status === "CONCLUIDA") {
            this.statusCobrancaPix = "CONCLUIDA";

            this.pixConcluido(step);
          } else {
            if (this.destroy !== true) {
              this.goToStep(step);
            }
          }
        })
        .catch((error) => (this.erro = error.response.data))
    },
    pixConcluido() {
      this.loading = true;
      localStorage.removeItem("simulacao-plano");
      this.$router.push(`/planos/simulador-step-4`);
    },
  }
};
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif
}

.container {
  margin: 30px auto;
}

.container .card {
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background: #fff;
  border-radius: 0px;
}

body {
  background: #eee
}



.btn.btn-primary {
  background-color: #ddd;
  color: black;
  box-shadow: none;
  border: none;
  font-size: 20px;
  width: 100%;
  height: 100%;
}

.btn.btn-primary:focus {
  box-shadow: none;
}

.container .card .img-box {
  width: 80px;
  height: 50px;
}

.container .card img {
  width: 100%;
  object-fit: fill;
}

.container .card .number {
  font-size: 24px;
}

.container .card-body .btn.btn-primary .fab.fa-cc-paypal {
  font-size: 32px;
  color: #3333f7;
}

.fab.fa-cc-amex {
  color: #1c6acf;
  font-size: 32px;
}

.fab.fa-cc-mastercard {
  font-size: 32px;
  color: red;
}

.fab.fa-cc-discover {
  font-size: 32px;
  color: orange;
}

.c-green {
  color: green;
}

.box {
  height: 40px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ddd;
}

.btn.btn-primary.payment {
  background-color: #1c6acf;
  color: white;
  border-radius: 0px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
}


.form__div {
  height: 50px;
  position: relative;
  margin-bottom: 24px;
  margin-left: 10px;
}

.form-control {
  width: 100%;
  height: 45px;
  font-size: 14px;
  border: 1px solid #DADCE0;
  border-radius: 0;
  outline: none;
  padding: 2px;
  background: none;
  z-index: 1;
  box-shadow: none;
}

.form__label {
  position: absolute;
  left: 16px;
  top: 10px;
  background-color: #fff;
  color: #80868B;
  font-size: 16px;
  transition: .3s;
  text-transform: uppercase;
}

.form-control:focus+.form__label {
  top: -8px;
  left: 12px;
  color: #1A73E8;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
}

.form-control:not(:placeholder-shown).form-control:not(:focus)+.form__label {
  top: -8px;
  left: 12px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
}

.form-control:focus {
  border: 1.5px solid #1A73E8;
  box-shadow: none;
}

.icon-seguro {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  transition: 0.5s;
  color: var(--cor-principal);
  overflow: hidden;
}

.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 35px;
  transition: 0.5s;
  color: var(--cor-principal);
  overflow: hidden;
}

.card-selecionado {
  border-color: var(--cor-principal);
}

.card-cartao {
  max-width: 350px;
}

.card-codigo-barra {
  background-color: #eee;
  min-width: 90%;
  min-height: 150px;
  border-radius: 7px;
  display: inline-grid;
  flex-wrap: wrap;
  align-content: center;
  margin-left: 5%;
}
</style>
